import ResponsePopup from 'src/components/SuitesTable/ResponsePopup';
import React from 'react';

interface SuitesResponsePopupProps {
  isSuccess: boolean;
  suitesResponse: any[] | null;
  error: string | null;
  onClear: () => void;
}

const SuitesResponsePopup = ({
  isSuccess,
  suitesResponse,
  error,
  onClear,
}: SuitesResponsePopupProps) => {
  if (isSuccess && suitesResponse && suitesResponse.length > 0) {
    return <ResponsePopup data={suitesResponse} onPress={onClear} />;
  }

  return null;
};

export default SuitesResponsePopup;
